import { NgModule } from '@angular/core';
import { SharedPaymentModule } from '@arc/unified-payments-frontend/shared-payment';
import { SharedStoreModule } from '@arc/unified-payments-frontend/shared-stores';
import { PaymentFooterComponent } from './components/payment-footer/payment-footer.component';
import { PaymentFooterContainerComponent } from './components/payment-footer/payment-footer.container.component';
import { SubscriberAgreementComponent } from './components/subscriber-agreement/subscriber-agreement.component';
import { PaymentFooterStoreModule } from './store/payment-footer.store.module';

@NgModule({
  declarations: [
    PaymentFooterContainerComponent,
    PaymentFooterComponent,
    SubscriberAgreementComponent,
  ],
  imports: [SharedPaymentModule, SharedStoreModule, PaymentFooterStoreModule],
  exports: [
    PaymentFooterContainerComponent,
    PaymentFooterStoreModule,
    SubscriberAgreementComponent,
  ],
})
export class PaymentFooterModule {}
